module.exports = __webpack_public_path__ + "img/6.bffac6a3.jpg";